import * as React from "react";
import { PagerModel } from "./PagerModel";
import { DataTable, DataTableAction, Renderer } from "./DataTable";
import { AdminEntityService } from "../../service/admin/AdminEntityService";
import { ListRequest } from "../../../generated/protocol";
import * as _ from "lodash";
import { AppCtx } from "../../ioc/ApplicationContext";
import { UserStoreState } from "../../store/UserStore";
import { extractPathParams, toPathParams } from "../../utils/UrlUtils";

interface Props {
    service?: AdminEntityService<any>;
    listRequest?: ListRequest;
    columns: Array<{ property: string, name: string, renderer?: Renderer<any> }>;
    dateEnabled?: boolean;
    onPagerChange?: (pager: PagerModel) => void;
    onDateChange?: (date: number, pager: PagerModel) => void;
    onAction?: (item: any, actionId: string) => void | Promise<boolean | any>;
    actions?: Array<DataTableAction>;
    showIndex?: boolean;
    onResults?: (result: any) => void;
}

interface State {
    items?: any[];
    pager?: PagerModel;
    date?: number;
    loading?: boolean;
    removed?: number[];
    itemsUpdating?: number[];
    operatorId?: number;

}

export class EntityDataTable extends React.Component<Props, State> {
    unsubscribe: () => void;
    mounted?: boolean = false;

    constructor(props: Props) {
        super(props);
        let operatorId = AppCtx.getUserStore().getState().activeOperator;
        this.state = { items: [], loading: false, removed: [], itemsUpdating: [], operatorId };
    }

    componentDidMount() {
        this.mounted = true;

        this.unsubscribe = AppCtx.getUserStore().listen((state: UserStoreState) => {
            if (this.mounted == true) {
                this.setState({ operatorId: state.activeOperator });
            }
        });

        this.doSearch();
    }

    getPager(listRequest: ListRequest): PagerModel {
        var pager = new PagerModel();
        pager.orderBy = listRequest.orderBy;
        pager.ascending = listRequest.ascending;
        pager.offset = listRequest.offset;
        pager.limit = listRequest.limit;
        return pager;
    }

    componentWillUnmount() {
        this.mounted = false;
        this.unsubscribe();
    }

    componentDidUpdate(previousProps: Props, previousState: State) {
        if (!this.state.pager && this.props.listRequest) {
            this.setState({ pager: this.getPager(this.props.listRequest) });
        }

        let prev = toPathParams(previousProps.listRequest);
        let current = toPathParams(this.props.listRequest);
        if (prev != current || this.state.operatorId != previousState.operatorId || this.state.date != previousState.date) {
            this.doSearch();
        }
    }

    doSearch() {
        console.log("DO SEARCH ", this.props);
        if (!this.props.service || !this.props.listRequest) {
            return;
        }
        this.setState({ loading: true, removed: [] });

        this.props.service.list(this.props.listRequest).then(listResponse => {
            var pager = new PagerModel(this.state.pager, listResponse.nrOfResults);
            var list: any[] = listResponse["items"];
            if (this.mounted == true) {
                this.setState({ items: list, pager, loading: false });
                if (this.props.onResults) {
                    this.props.onResults(listResponse);
                }
            }
        });

    }

    manualSearch() {
        this.doSearch();
    }

    onAction(item: any, id: string, index: number) {
        var result: void | Promise<boolean | any> = this.props.onAction(item, id);
        if (typeof result !== "undefined" && id == "delete") {
            let promise = (result as Promise<{} | any>);

            let addedItemUpdating = [...this.state.itemsUpdating, index];
            this.setState({ itemsUpdating: addedItemUpdating });

            promise.then(() => {
                let removedItems = [...this.state.removed, index];
                let tookTheItemOut = this.state.itemsUpdating.filter(item => item !== index);
                this.setState({ removed: removedItems, itemsUpdating: tookTheItemOut });
            }).catch(() => {
                let tookTheItemOut = this.state.itemsUpdating.filter(item => item !== index);
                this.setState({ itemsUpdating: tookTheItemOut });
            });
        }
    }

    onPagerChange(pager: PagerModel) {
        this.setState({ pager: pager });
        this.props.onPagerChange(pager);
    }

    onDateChange(date: number, pager: PagerModel) {
        this.setState({ pager: pager });
        this.props.onDateChange(date, pager);
    }

    render() {
        return (
            <div className="ibox float-e-margins">
                {this.renderDataTable()}
            </div>
        );
    }

    renderDataTable() {
        if (!this.state.pager) return;

        return (<DataTable onAction={this.onAction.bind(this)}
            date={this.state.date}
            dateEnabled={this.props.dateEnabled}
            onDateChange={this.onDateChange.bind(this)}
            onPagerChange={this.onPagerChange.bind(this)}
            items={this.state.items}
            columns={this.props.columns}
            pager={this.state.pager}
            loading={this.state.loading}
            actions={this.props.actions}
            removed={this.state.removed}
            itemsUpdating={this.state.itemsUpdating}
            showIndex={this.props.showIndex}
        />);
    }

}



// WEBPACK FOOTER //
// ./src/app/ui/list/EntityDataTable.tsx